export default "__VITE_ASSET__21887be2__$_?component__"